import type { IssuedServiceToken, ServiceTokenRow, UserRow } from './types';

async function parseJson<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const j = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(j.error ?? `HTTP ${res.status}`);
  }
  return (await res.json()) as T;
}

export interface UsersResponse {
  users: UserRow[];
  view_ids: readonly string[];
}

export async function fetchUsers(): Promise<UsersResponse> {
  const res = await fetch('/api/admin/users');
  return parseJson<UsersResponse>(res);
}

export async function updateUser(
  id: string,
  patch: Partial<Pick<UserRow, 'display_name' | 'role' | 'department' | 'active' | 'permissions'>>,
): Promise<void> {
  const res = await fetch(`/api/admin/users/${id}`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(patch),
  });
  await parseJson<{ user: unknown }>(res);
}

export async function fetchServiceTokens(): Promise<ServiceTokenRow[]> {
  const res = await fetch('/api/service-tokens');
  const json = await parseJson<{ tokens: ServiceTokenRow[] }>(res);
  return json.tokens;
}

export async function issueServiceToken(
  boundUserId: string,
  name?: string,
): Promise<IssuedServiceToken> {
  const res = await fetch('/api/service-tokens', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ bound_user_id: boundUserId, ...(name ? { name } : {}) }),
  });
  return parseJson<IssuedServiceToken>(res);
}

export async function revokeServiceToken(id: string): Promise<void> {
  const res = await fetch(`/api/service-tokens/${id}/revoke`, { method: 'POST' });
  await parseJson<{ ok: true }>(res);
}
